import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store';
import Login from '@/views/login/Login.vue'
import Dashboard from '@/views/dashboard/Dashboard.vue'
import MainLayout from '@/layouts/MainLayout.vue';
import Setting from '@/views/dashboard/Setting.vue';
import ListeUser from '@/views/user/ListeUser.vue';
import CreateUser from '@/views/user/CreateUser.vue';
import EditUser from '@/views/user/editUser.vue';
import ListeTypeUser from '@/views/typeUser/ListeTypeUser.vue';
import CreateTypeUser from '@/views/typeUser/CreateTypeUser.vue';
import ListePatient from '@/views/patient/ListePatient.vue';
import CreatePatient from '@/views/patient/CreatePatient.vue';
import EditPatient from '@/views/patient/editPatient.vue';
import Dossier from '@/views/patient/Dossier.vue';
import ListeTypeConsultation from '@/views/typeConsultation/ListeTypeConsultation.vue';
import CreateTypeConsultation from '@/views/typeConsultation/CreateTypeConsultation.vue';
import EditTypeConsultation from '@/views/typeConsultation/EditTypeConsultation.vue';
import ListeConsultation from '@/views/consultation/ListeConsultation.vue';
import RecuConsultation from '@/views/consultation/consultation/RecuConsultation.vue';
import ListeAssurance from '@/views/assurance/ListeAssurance.vue';
import CreateAssurance from '@/views/assurance/CreateAssurance.vue';
import ConfigurationSysteme from '@/views/config/ConfigurationSysteme.vue';
import CreateConfiguration from '@/views/config/CreateConfiguration.vue';
import EditConfigurationSysteme from '@/views/config/EditConfigurationSysteme.vue';
import ListePaiementConsultation from '@/views/consultation/consultation/ListePaiementConsultation.vue';
import EditAssurance from '@/views/assurance/EditAssurance.vue';
import ListeMedicament from '@/views/pharmacie/ListeMedicament.vue';
import CreateMedicament from '@/views/pharmacie/CreateMedicament.vue';
import TraitementConsultation from '@/views/consultation/TraitementConsultation.vue';
import ListeConditionnement from '@/views/conditionnement/ListeConditionnement.vue';
import CreateConditionnement from '@/views/conditionnement/CreateConditionnement.vue';
import EditConditionnement from '@/views/conditionnement/EditConditionnement.vue';
import ListeApprovisionnement from '@/views/approvisionnement/ListeApprovisionnement.vue';
import CreateApprovisionnement from '@/views/approvisionnement/CreationApprovisionement.vue';
import EditApprovisionnement from '@/views/approvisionnement/EditApprovisionnement.vue';
import DetailsMedicament from '@/views/pharmacie/DetailsMedicament.vue';
import EditTraitement from '@/views/consultation/EditTraitement.vue';
import ListeTypeChambre from '@/views/typeChambre/ListeTypeChambre.vue';
import CreateTypeChambre from '@/views/typeChambre/CreateTypeChambre.vue';
import EditTypeChambre from '@/views/typeChambre/EditTypeChambre.vue';
import ListeChambre from '@/views/chambre/ListeChambre.vue';
import CreateChambre from '@/views/chambre/CreateChambre.vue';
import EditChambre from '@/views/chambre/EditChambre.vue';
import ListeLit from '@/views/lit/ListeLit.vue';
import CreateLit from '@/views/lit/CreateLit.vue';
import EditLit from '@/views/lit/EditLit.vue';
import ListeTypeHospitalisation from '@/views/typeHospitalisation/ListeTypeHospitalisation.vue';
import CreateTypeHospitalisation from '@/views/typeHospitalisation/CreateTypeHospitalisation.vue';
import EditTypeHospitalisation from '@/views/typeHospitalisation/EditTypeHospitalisation.vue';
import ListeHospitalisation from '@/views/hospitalisation/ListeHospitalisation.vue';
import CreateHospitalisation from '@/views/hospitalisation/CreateHospitalisation.vue';
import ListeMoyenPaiement from '@/views/moyenPaiement/ListeMoyenPaiement.vue';
import CreateMoyenPaiement from '@/views/moyenPaiement/CreateMoyenPaiement.vue';
import ReçuHospitalisation from '@/views/hospitalisation/ReçuHospitalisation.vue';
import Unauthorized from '@/views/Unauthorized.vue';
import EditTypeUser from '@/views/typeUser/EditTypeUser.vue';
import Compte from '@/views/user/Compte.vue';
import Information from '@/views/patient/tabs/Information.vue';
import ListeTypeExamen from '@/views/typeExamen/ListeTypeExamen.vue';
import CreateTypeExamen from '@/views/typeExamen/CreateTypeExamen.vue';
import EditTypeExamen from '@/views/typeExamen/EditTypeExamen.vue';
import ListeFrequence from '@/views/frequence/ListeFrequence.vue';
import CreateFrequence from '@/views/frequence/CreateFrequence.vue';
import EditFrequence from '@/views/frequence/EditFrequence.vue';
import ListeDureeMedicament from '@/views/dureMedicament/ListeDureeMedicament.vue';
import CreateDureeMedicament from '@/views/dureMedicament/CreateDureeMedicament.vue';
import EditDureeMedicament from '@/views/dureMedicament/EditDureeMedicament.vue';
import DetailsHospitalisation from '@/views/hospitalisation/DetailsHospitalisation.vue';
import ListePaiement from '@/views/transaction/ListePaiement.vue';
import ListeTypeService from '@/views/typeService/ListeTypeService.vue';
import EditTypeService from '@/views/typeService/EditTypeService.vue';
import CreateTypeService from '@/views/typeService/CreateTypeService.vue';
import ListeService from '@/views/service/ListeService.vue';
import CreateService from '@/views/service/CreateService.vue';
import EditService from '@/views/service/EditService.vue';


const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
  path: '/mot-de-passe-oublie',
  name: 'forgot_password',
  component: () => import('@/views/login/ForgotPassword.vue'),
  meta: { public: true }
},
{
  path: '/reset-password',
  name: 'reset_password',
  component: () => import('@/views/login/ResetPassword.vue'),
  meta: { public: true }
},
  {
    path: '/',
    component: MainLayout, // Layout principal

    children: [
      {
        path: '',
        name: 'Dashboard',
        component: Dashboard,
        meta: {
          requiresAuth: true,
          permissions: ['DASHBOARD']
        }
      },
      {
        path: '/compte',
        name: 'compte',
        component: Compte,
        meta: {
          requiresAuth: true
        },
      },

      // ============================================================
      // PATIENTS
      // ============================================================
      {
        path: '/patients',
        name: 'patients',
        component: ListePatient,
        meta: {
          requiresAuth: true,
          permissions: ['PATIENT_LIST'],
          section: 'patients',
          menuOrder: 2
        }
      },
      {
        path: '/patients/creation',
        name: 'create_patient',
        component: CreatePatient,
        meta: {
          requiresAuth: true,
          permissions: ['PATIENT_CREATE'],
          section: 'patients'
        }
      },
      {
        path: '/patients/:id',
        name: 'edit_patient',
        component: EditPatient,
        meta: {
          requiresAuth: true,
          permissions: ['PATIENT_EDIT'],
          section: 'patients'
        }
      },

      // ============================================================
      // CONSULTATIONS
      // ============================================================
      {
        path: 'consultations_',
        name: 'consultations_',
        component: ListeConsultation,
        meta: {
          requiresAuth: true,
          permissions: ['CONSULT_VIEW'],
          section: 'consultations',
          menuOrder: 3
        }
      },
      {
        path: '/consultation/:id/recu',
        name: 'recu_consultation',
        component: RecuConsultation,
        meta: {
          requiresAuth: true,
          permissions: ['CONSULT_IMPRESSION'],
          section: 'consultations'
        }
      },
      {
        path: '/consultations/:id/traitements',
        name: 'traitement_consultation',
        component: TraitementConsultation,
        meta: {
          requiresAuth: true,
          permissions: ['CONSULT_TRAITER'],
          section: 'consultations'
        }
      },
      {
        path: '/consultations/:id/traitements/modification',
        name: 'edit_traitement',
        component: EditTraitement,
        meta: {
          requiresAuth: true,
          permissions: ['CONSULT_TRAITER'],
          section: 'consultations'
        }
      },

      // ============================================================
      // ASSURANCES (configuration)
      // ============================================================
      {
        path: '/assurances',
        name: 'liste_assurance',
        component: ListeAssurance,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_LISTE_ASSURANCE'],
          section: 'configuration',
          menuOrder: 12
        }
      },
      {
        path: '/assurances/:id',
        name: 'edit_assurance',
        component: EditAssurance,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_Modifier_ASSURANCE'],
          section: 'configuration'
        }
      },
      {
        path: '/assurances/creation',
        name: 'create_assurance',
        component: CreateAssurance,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_CREER_ASSURANCE'],
          section: 'configuration'
        }
      },

      // ============================================================
      // ADMINISTRATION > Configuration système
      // ============================================================
      {
        path: '/configurations',
        name: 'item_config',
        component: ConfigurationSysteme,
        meta: {
          requiresAuth: true,
          permissions: ['VIEW_CONFIGURATION_SYSTEME'],
          section: 'administration',
          menuOrder: 24
        }
      },
      {
        path: '/configurations/creation',
        name: 'create_configuration_systeme',
        component: CreateConfiguration,
        meta: {
          requiresAuth: true,
          permissions: ['CREATE_CONFIGURATION_SYSTEME'],
          section: 'administration'
        }
      },
      {
        path: '/configurations/:id/edit',
        name: 'edit_configuration_systeme',
        component: EditConfigurationSysteme,
        meta: {
          requiresAuth: true,
          permissions: ['EDIT_CONFIGURATION_SYSTEME'],
          section: 'administration'
        }
      },

      // ============================================================
      // CONDITIONNEMENT (configuration)
      // ============================================================
      {
        path: '/conditionnements',
        name: 'conditionnements',
        component: ListeConditionnement,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_LISTE_CONDITIONNEMENT'],
          section: 'configuration',
          menuOrder: 13
        }
      },
      {
        path: '/conditionnements/nouveau',
        name: 'create_conditionnement',
        component: CreateConditionnement,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_CREER_CONDITIONNEMENT'],
          section: 'configuration'
        }
      },
      {
        path: '/conditionnements/:id',
        name: 'edit_conditionnement',
        component: EditConditionnement,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_MODIFIER_CONDITIONNEMENT'],
          section: 'configuration'
        }
      },

      // ============================================================
      // APPROVISIONNEMENT (ancienne implémentation - non liée à la sidebar,
      // conservée telle quelle pour ne rien casser)
      // ============================================================
      {
        path: '/approvisionnements',
        name: 'liste_approvisionnement',
        component: ListeApprovisionnement,
        meta: {
          requiresAuth: true,
          permissions: ['LISTE_APPROVISIONNEMENT']
        }
      },
      {
        path: '/approvisionnements/:id',
        name: 'edit_approvisionnement',
        component: EditApprovisionnement,
        meta: {
          requiresAuth: true,
          permissions: ['EDIT_APPROVISIONNEMENT']
        }
      },
      {
        path: '/approvisionnements/nouveau',
        name: 'create_approvisionnement',
        component: CreateApprovisionnement,
        meta: {
          requiresAuth: true,
          permissions: ['CREER_APPROVISIONNEMENT']
        }
      },

      // ============================================================
      // MEDICAMENTS (ancienne implémentation, non liée à la sidebar)
      // ============================================================
      {
        path: '/medicaments',
        name: 'liste_medicaments',
        component: ListeMedicament,
        meta: {
          requiresAuth: true,
          permissions: ['view_pharmacie']
        }
      },
      {
        path: '/medicaments/nouveau',
        name: 'create_medicament',
        component: CreateMedicament,
        meta: {
          requiresAuth: true,
          permissions: ['MEDICAMENT_CREER']
        }
      },
      {
        path: '/medicaments/:id/details',
        name: 'details',
        component: DetailsMedicament,
        meta: {
          requiresAuth: true,
          permissions: ['MEDICAMENT_DETAILS']
        }
      },

      // ============================================================
      // PHARMACIE > PRODUITS
      // ============================================================
      {
        path: '/produits',
        name: 'produits',
        component: () => import('@/views/produits/ProduitList.vue'),
        meta: {
          requiresAuth: true,
          permissions: ['PRODUIT_LIST'],
          section: 'pharmacie',
          menuOrder: 6
        }
      },
      {
        // Corrigé : partageait le path '/produits' avec la route 'produits' ci-dessus.
        // Vos boutons naviguent par `name`, donc ça fonctionnait au clic,
        // mais un F5 sur cette page retombait sur la liste.
        path: '/produits/creation',
        name: 'create_produit',
        component: () => import('@/views/produits/CreateProduit.vue'),
        meta: {
          requiresAuth: true,
          permissions: ['PRODUIT_CREATION'],
          section: 'pharmacie'
        }
      },
      {
        path: '/produits/:id/edit',
        name: 'edit_produit',
        component: () => import('@/views/produits/EditProduit.vue'),
        meta: {
          requiresAuth: true,
          permissions: ['PRODUIT_UPDATE'],
          section: 'pharmacie'
        }
      },

      // ============================================================
      // PHARMACIE > APPROVISIONNEMENT
      // ============================================================
      {
        path: '/approvs',
        name: 'approvs',
        component: () => import('@/views/approv/ListeApprov.vue'),
        meta: {
          requiresAuth: true,
          permissions: ['LISTE_APPROVISIONNEMENT'],
          section: 'pharmacie',
          menuOrder: 7
        }
      },
      {
        path: '/approv/:id',
        name: 'detail_approv',
        component: () => import('@/views/approv/DetailApprov.vue'),
        meta: {
          requiresAuth: true,
          permissions: ['VOIR_APPROVISIONNEMENT'],
          section: 'pharmacie'
        }
      },
      {
        // Corrigé : partageait le path '/approv/:id' avec 'detail_approv'.
        path: '/approv/:id/edit',
        name: 'edit_approv',
        component: () => import('@/views/approv/EditApprov.vue'),
        meta: {
          requiresAuth: true,
          permissions: ['Voir_APPROVISIONNEMENT'],
          section: 'pharmacie'
        }
      },
      {
        // Corrigé : partageait le path '/approvs' avec la route 'approvs' (liste).
        path: '/approvs/creation',
        name: 'approv-creation',
        component: () => import('@/views/approv/CreateApprov.vue'),
        meta: {
          requiresAuth: true,
          permissions: ['CREER_APPROVISIONNEMENT'],
          section: 'pharmacie'
        }
      },

      // ============================================================
      // PHARMACIE > STOCK PAR LOT
      // ============================================================
      {
        path: '/stocks-lots',
        name: 'stocks_lots',
        component: () => import('@/views/stock/LotsStock.vue'),
        meta: {
          // Corrigé : c'était `permission` (singulier), donc le guard de navigation
          // ne vérifiait AUCUN droit sur cette route (accessible à tout utilisateur connecté).
          requiresAuth: true,
          permissions: ['LOT_PRODUIT'],
          section: 'pharmacie',
          menuOrder: 9
        }
      },

      // ============================================================
      // PHARMACIE > VENTE / CAISSE
      // ============================================================
      {
        path: '/ventes',
        name: 'LISTE_VENTE',
        component: () => import('@/views/vente/ListeVente.vue'),
        meta: {
          requiresAuth: true,
          permissions: ['LISTE_VENTE'],
          section: 'pharmacie',
          menuOrder: 8
        }
      },
      {
        path: '/ventes/create',
        name: 'vente-caisse-create',
        component: () => import('@/views/vente/VenteCaisse.vue'),
        meta: {
          requiresAuth: true,
          permissions: ['LISTE_VENTE'],
          section: 'pharmacie'
        }
      },

      // ============================================================
      // TRANSACTIONS
      // ============================================================
      {
        path: '/paiements',
        name: 'liste_paiements',
        component: ListePaiement,
        meta: {
          requiresAuth: true,
          permissions: ['TRANS_LIST_AUTRES_SERVICES'],
          section: 'transactions',
          menuOrder: 11
        }
      },
      {
        path: '/paiement_consultations_',
        name: 'liste_paiement_consultation',
        component: ListePaiementConsultation,
        meta: {
          requiresAuth: true,
          permissions: ['TRANS_LIST_CONSULTATION'],
          section: 'transactions',
          menuOrder: 10
        }
      },

      // ============================================================
      // DOSSIER PATIENT (onglets)
      // meta.section='patients' hérité automatiquement par tous les enfants
      // ============================================================
      {
        path: '/dossiers/:id',
        name: 'dossier_patient',
        component: Dossier,
        meta: {
          requiresAuth: true,
          permissions: ['PATIENT_DOSSIER'],
          section: 'patients'
        },
        children: [
          {
            path: '',
            redirect: { name: 'information_personnelle' }
          },
          {
            path: 'informations',
            name: 'information_personnelle',
            component: Information,
          },
          {
            path: 'consultations',
            name: 'consultations_patient',
            component: () => import('@/views/patient/tabs/ConsultationsPatient.vue')
          },
          {
            path: 'assurances',
            name: 'assurances_patient',
            component: () => import('@/views/patient/AssurancesPatient.vue')
          },
          {
            path: 'ordonnances',
            name: 'ordonnances_patient',
            component: () => import('@/views/patient/tabs/OrdonnancesPatient.vue'),
          },
          {
            path: 'factures',
            name: 'factures_patient',
            component: () => import('@/views/patient/tabs/FacturesPatient.vue')
          },
          {
            path: 'analyses',
            name: 'analyses_patient',
            component: () => import('@/views/patient/tabs/AnalysesPatient.vue')
          },
          {
            path: 'hospitalisations',
            name: 'hospitalisations_patient',
            component: () => import('@/views/patient/tabs/HospitalisationPatient')
          },
          {
            path: '/patients/:id/services',
            name: 'services_patient',
            component: () => import('@/views/patient/tabs/PatientServices.vue'),
            props: true
          }
        ]
      },

      {
        path: '/setting',
        name: 'setting',
        component: Setting
      },

      // ============================================================
      // HOSPITALISATION
      // ============================================================
      {
        path: '/hospitalisation/:id/details',
        name: 'details_hospitalisation',
        component: DetailsHospitalisation,
        meta: {
          requiresAuth: true,
          permissions: ['HOSP_DESTAILS'],
          section: 'hospitalisation'
        }
      },
      {
        path: '/hospitalisations',
        name: 'liste_hospitalisation',
        component: ListeHospitalisation,
        meta: {
          requiresAuth: true,
          permissions: ['HOSP_VIEW'],
          section: 'hospitalisation',
          menuOrder: 4
        }
      },
      {
        // Corrigé : partageait le path '/hospitalisations' avec la liste.
        path: '/hospitalisations/creation',
        name: 'create_hospitalisation',
        component: CreateHospitalisation,
        meta: {
          requiresAuth: true,
          permissions: ['HOSP_CREATE'],
          section: 'hospitalisation'
        }
      },
      {
        path: '/recu_hospitalisation/:id',
        name: 'reçu_hospitalisation',
        component: ReçuHospitalisation,
        meta: {
          requiresAuth: true,
          section: 'hospitalisation'
        }
      },


      // ============================================================
      // CONFIGURATION > TYPE SERVICE / SERVICE
      // ============================================================
      {
        path: '/type_services',
        name: 'liste_type_service',
        component: ListeTypeService,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_LISTE_TYPE_Service'],
          section: 'configuration',
          menuOrder: 17
        }
      },
      {
        path: '/type_services/:id',
        name: 'edit_type_service',
        component: EditTypeService,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_MODIFIER_TYPE_SERVICE'],
          section: 'configuration'
        }
      },
      {
        path: '/type_service',
        name: 'create_type_service',
        component: CreateTypeService,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_CREER_TYPE_SERVICE'],
          section: 'configuration'
        }
      },
      {
        path: '/services',
        name: 'liste_service',
        component: ListeService,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_LISTE_SERVICE'],
          section: 'configuration',
          menuOrder: 18
        }
      },
      {
        // Corrigé : partageait le path '/services' avec la liste.
        path: '/services/creation',
        name: 'create_service',
        component: CreateService,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_CREER_SERVICE'],
          section: 'configuration'
        }
      },
      {
        path: '/services/:id',
        name: 'edit_service',
        component: EditService,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_MODIFIER_SERVICE'],
          section: 'configuration'
        }
      },

      // ============================================================
      // CONFIGURATION > TYPE EXAMEN
      // ============================================================
      {
        path: '/type_examens',
        name: 'liste_type_examen',
        component: ListeTypeExamen,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_LISTE_TYPE_EXAMEN'],
          section: 'configuration',
          menuOrder: 16
        }
      },
      {
        // Corrigé : path relatif 'type_examens' résolvait déjà vers '/type_examens',
        // en collision avec la liste ci-dessus.
        path: 'type_examens/creation',
        name: 'create_type_examen',
        component: CreateTypeExamen,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_CREER_TYPE_EXAMEN'],
          section: 'configuration'
        }
      },
      {
        path: '/type_examens/:id',
        name: 'edit_type_examen',
        component: EditTypeExamen,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_MODIFIER_TYPE_EXAMEN'],
          section: 'configuration'
        }
      },

      // ============================================================
      // CONFIGURATION > POSOLOGIE (FREQUENCE)
      // ============================================================
      {
        path: '/frequences',
        name: 'liste_frequence',
        component: ListeFrequence,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_LISTE_FREQUENCE'],
          section: 'configuration',
          menuOrder: 19
        }
      },
      {
        // Corrigé : partageait le path '/frequences' avec la liste.
        path: '/frequences/creation',
        name: 'create_frequence',
        component: CreateFrequence,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_CREER_FREQUENCE'],
          section: 'configuration'
        }
      },
      {
        path: '/frequences/:id',
        name: 'edit_frequence',
        component: EditFrequence,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_MODIFIER_TYPE_EXAMEN'],
          section: 'configuration'
        }
      },

      // ============================================================
      // CONFIGURATION > DUREE MEDICAMENT
      // ============================================================
      {
        path: '/duree_medicaments',
        name: 'liste_duree_medicament',
        component: ListeDureeMedicament,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_LISTE_DUREE_MEDICAMENT'],
          section: 'configuration',
          menuOrder: 20
        }
      },
      {
        // Corrigé : partageait le path '/duree_medicaments' avec la liste.
        path: '/duree_medicaments/creation',
        name: 'create_duree_medicament',
        component: CreateDureeMedicament,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_CREER_DUREE_MEDICAMENT'],
          section: 'configuration'
        }
      },
      {
        path: '/dure_medicaments/:id',
        name: 'edit_duree_medicament',
        component: EditDureeMedicament,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_MODIFIER_DUREE_MEDICAMENT'],
          section: 'configuration'
        }
      },

      // ============================================================
      // ADMINISTRATION > UTILISATEURS
      // ============================================================
      {
        path: '/utilisateurs',
        name: 'utilisateur',
        component: ListeUser,
        meta: {
          requiresAuth: true,
          permissions: ['ADMIN_LISTE_UTILISATEUR'],
          section: 'administration',
          menuOrder: 26
        }
      },
      {
        path: '/utilisateurs/creation',
        name: 'create_utilisateur',
        component: CreateUser,
        meta: {
          requiresAuth: true,
          permissions: ['ADMIN_CREATION_UTILISATEUR'],
          section: 'administration'
        }
      },
      {
        path: '/utilisateurs/:id',
        name: 'edit_user',
        component: EditUser,
        meta: {
          requiresAuth: true,
          permissions: ['ADMIN_EDIT_UTILISATEUR'],
          section: 'administration'
        }
      },

      // ============================================================
      // CONFIGURATION > MOYEN DE PAIEMENT
      // ============================================================
      {
        path: '/moyen_paiements',
        name: 'liste_moyen_paiement',
        component: ListeMoyenPaiement,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_MOYEN_PAIEMENT'],
          section: 'configuration',
          menuOrder: 14
        }
      },
      {
        // Corrigé : partageait le path '/moyen_paiements' avec la liste.
        path: '/moyen_paiements/creation',
        name: 'create_moyen',
        component: CreateMoyenPaiement,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_CREER_MOYEN__PAIEMENT'],
          section: 'configuration'
        }
      },

      // ============================================================
      // CONFIGURATION > TYPE CHAMBRE
      // ============================================================
      {
        path: '/type_chambres',
        name: 'liste_type_chambre',
        component: ListeTypeChambre,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_TYPE_CHAMBRE'],
          section: 'configuration',
          menuOrder: 22
        }
      },
      {
        // Corrigé : partageait le path '/type_chambres' avec la liste.
        path: '/type_chambres/creation',
        name: 'create_type_chambre',
        component: CreateTypeChambre,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_CREER_TYPE_CHAMBRE'],
          section: 'configuration'
        }
      },
      {
        path: '/type_chambres/:id',
        name: 'edit_type_chambres',
        component: EditTypeChambre,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_MODIFIER_TYPE_CHAMBRE'],
          section: 'configuration'
        }
      },

      // ============================================================
      // HOSPITALISATION > CHAMBRES
      // ============================================================
      {
        path: '/chambres',
        name: 'liste_chambre',
        component: ListeChambre,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_CHAMBRE'],
          section: 'hospitalisation',
          menuOrder: 5
        }
      },
      {
        // Corrigé : partageait le path '/chambres' avec la liste.
        path: '/chambres/creation',
        name: 'create_chambre',
        component: CreateChambre,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_CREER_CHAMBRE'],
          section: 'hospitalisation'
        }
      },
      {
        path: '/chambres/:id',
        name: 'edit_chambre',
        component: EditChambre,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_MODIFIER_CHAMBRE'],
          section: 'hospitalisation'
        }
      },

      // ============================================================
      // CONFIGURATION > LITS
      // ============================================================
      {
        path: '/lits',
        name: 'liste_lit',
        component: ListeLit,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_LIT'],
          section: 'configuration',
          menuOrder: 23
        }
      },
      {
        // Corrigé : partageait le path '/lits' avec la liste.
        path: '/lits/creation',
        name: 'create_lit',
        component: CreateLit,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_CREER_LIT'],
          section: 'configuration'
        }
      },
      {
        path: '/lits/:id',
        name: 'edit_lit',
        component: EditLit,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_MODIFIER_LIT'],
          section: 'configuration'
        }
      },

      // ============================================================
      // CONFIGURATION > TYPE HOSPITALISATION
      // ============================================================
      {
        path: '/type_hospitalisations',
        name: 'liste_type_hospitalisation',
        component: ListeTypeHospitalisation,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_TYPE_HOSPITALISATION'],
          section: 'configuration',
          menuOrder: 21
        }
      },
      {
        // Corrigé : partageait le path '/type_hospitalisations' avec la liste.
        path: '/type_hospitalisations/creation',
        name: 'create_type_hospitalisation',
        component: CreateTypeHospitalisation,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_CREER_TYPE_HOSPITALISATION'],
          section: 'configuration'
        }
      },
      {
        path: '/type_hospitalisation/:id',
        name: 'edit_type_hospitalisation',
        component: EditTypeHospitalisation,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_MODIFIER_TYPE_HOSPITALISATION'],
          section: 'configuration'
        }
      },

      // ============================================================
      // CONFIGURATION > TYPE CONSULTATION
      // ============================================================
      {
        path: '/type_consultations',
        name: 'type_consultation',
        component: ListeTypeConsultation,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_LISTE_TYPE_CONSULTATION'],
          section: 'configuration',
          menuOrder: 15
        }
      },
      {
        path: '/type_consultation/creation',
        name: 'create_type_consultation',
        component: CreateTypeConsultation,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_CREER_TYPE_CONSULTATION'],
          section: 'configuration'
        }
      },
      {
        path: '/type_consultations/:id',
        name: 'edit_type_consultation',
        component: EditTypeConsultation,
        meta: {
          requiresAuth: true,
          permissions: ['CONFIG_MODIFIER_TYPE_CONSULTATION'],
          section: 'configuration'
        }
      },

      // ============================================================
      // ADMINISTRATION > ROLES
      // ============================================================
      {
        path: '/roles',
        name: 'role',
        component: ListeTypeUser,
        meta: {
          requiresAuth: true,
          permissions: ['ADMIN_LISTE_ROLE'],
          section: 'administration',
          menuOrder: 25
        }
      },
      {
        path: '/type_users/creation',
        name: 'create_type_users',
        component: CreateTypeUser,
        meta: {
          requiresAuth: true,
          permissions: ['ADMIN_CREER_ROLE'],
          section: 'administration'
        }
      },
      {
        path: '/type_users/:id/edit',
        name: 'edit_type_users',
        component: EditTypeUser,
        props: true,
        meta: {
          requiresAuth: true,
          permissions: ['ADMIN_MODIFIER_ROLE'],
          section: 'administration'
        }
      },

      {
        path: '/unauthorized',
        name: 'unauthorized',
        component: Unauthorized
      },
    ],
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});


router.beforeEach(async (to, from, next) => {

  const token = store.state.token;

  // Pas de token
  if (to.meta.requiresAuth && !token) {
    return next("/login");
  }

  // Si token présent mais user absent (F5 par exemple)
  if (token && !store.state.user) {

    const ok = await store.dispatch("refreshUser");

    if (!ok) {
      return next("/login");
    }
  }

  const user = store.state.user;

  // Toujours rien ?
  if (to.meta.requiresAuth && !user) {
    return next("/login");
  }

  // Super Admin
  if (store.getters.isSuperAdmin) {
    return next();
  }

  // Permissions utilisateur
  const userPermissions = (store.state.permissions || []).map(p =>
    p.toLowerCase()
  );

  /**
   * Première route "liste" accessible, dans l'ordre RÉEL de la sidebar
   * (meta.menuOrder), et non plus dans l'ordre d'enregistrement des routes.
   */
  const getFirstListingRoute = () => {

    return router.getRoutes()
      .filter(route => route.meta?.menuOrder != null)
      .sort((a, b) => a.meta.menuOrder - b.meta.menuOrder)
      .find(route =>
        route.meta.permissions?.some(permission =>
          userPermissions.includes(permission.toLowerCase())
        )
      );

  };

  /**
   * Dashboard
   */
  if (to.path === "/" && !store.getters.hasPermission("DASHBOARD")) {

    const route = getFirstListingRoute();

    if (route) {
      return next({ name: route.name });
    }

    return next("/unauthorized");
  }

  /**
   * Permissions
   */
  if (to.meta.permissions) {

    const authorized = to.meta.permissions.some(permission =>
      store.getters.hasPermission(permission)
    );

    if (!authorized) {

      const route = getFirstListingRoute();

      if (route) {
        return next({ name: route.name });
      }

      return next("/unauthorized");
    }
  }

  next();

});


export default router